import { render, staticRenderFns } from "./FeeBindList.vue?vue&type=template&id=0475d6c6&scoped=true"
import script from "./FeeBindList.vue?vue&type=script&lang=js"
export * from "./FeeBindList.vue?vue&type=script&lang=js"
import style0 from "./FeeBindList.vue?vue&type=style&index=0&id=0475d6c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0475d6c6",
  null
  
)

export default component.exports